import Service from '@ember/service';
import { service } from '@ember/service';

export default class HeroApiBookingsService extends Service {
  @service('hero-api-bookings-allocations')
  allocations;
}
